import Select from 'react-select/creatable'
import { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectStyles } from 'apps/builder/components/shared'
import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { referenceImagesSelector } from 'apps/builder/store/selectors'
import { updateEntry } from 'apps/builder/store/actions/entries'

export const StaticImageField = ({
  guid,
  label,
  type,
  keyField,
  summary_entry_id
}) => {
  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
        />
      </div>
      <div className="settings--format--wrapper">
        <ReferenceImageDropdown
          guid={guid}
          label={label}
          summary_entry_id={summary_entry_id}
        />
      </div>
    </>
  )
}

const ReferenceImageDropdown = ({ guid, summary_entry_id }) => {
  const referenceImages = useSelector(referenceImagesSelector)
  const dispatch = useDispatch()

  const options = useMemo(() => {
    return [{ value: '', label: 'None' }].concat(
      referenceImages
        .map(({ id, name }) => ({ value: id, label: name }))
        .sort((a, b) => a.label.localeCompare(b.label))
    )
  }, [referenceImages])

  const value = options.find(({ value }) => value === summary_entry_id) || options[0]

  return (
    <div className="settings--field-type">
      <Select
        styles={selectStyles}
        className="input--placeholder"
        classNamePrefix="react-select"
        options={options}
        value={value}
        onChange={({ value }) => {
          dispatch(
            updateEntry({ guid, summary_entry_id: value })
          )
        }}
      />
      <label>Reference Image</label>
    </div>
  )
}
